export default "__VITE_ASSET__6sWtUB0E__"